import type { RouteRecordRaw } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import OrdersIndex from '@/views/orders/index.vue'
import OrderDetails from '@/views/orders/order-details.vue'

const ordersRoutes: RouteRecordRaw[] = [
  {
    path: '/orders',
    meta: { layout: DefaultLayout, middleware: ['auth'] },
    children: [
      { path: '', name: 'orders', component: OrdersIndex },
      { path: ':id', name: 'Order-Details', component: OrderDetails, props: true },
    ],
  },
]

export default ordersRoutes
